import React, { useEffect, useState, useRef } from "react";
import { db } from "../firebase";
import { onValue, ref } from "firebase/database";
import ProjectFrame from "./ProjectFrame";
import { useCardTilt } from "./useCardTilt";

const AnimatedProjectCard = ({ children, index }) => {
    const ref = useRef(null);
    useCardTilt(ref);
    React.useEffect(() => {
        const el = ref.current;
        if (!el) return;
        // Reveal everything that's already on screen immediately, and only
        // use IntersectionObserver to fade in the rest. Without this, the
        // first cards stay invisible until the observer ticks once.
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
            el.classList.add('visible');
            return;
        }
        const obs = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    el.classList.add('visible');
                    obs.disconnect();
                }
            });
        }, { threshold: 0.18 });
        obs.observe(el);
        return () => obs.disconnect();
    }, []);
    return (
        <div
            ref={ref}
            className="project-card-reveal"
            style={{ transitionDelay: `${Math.min((index % 12) * 60, 600)}ms` }}
        >
            {children}
        </div>
    );
};

const ProjectsHome = () => {
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        const query = ref(db, "Projects");
        return onValue(query, (snapshot) => {
            const data = snapshot.val();
            if (snapshot.exists()) {
                const collected = [];
                Object.values(data).forEach((companys) => {
                    collected.push(companys);
                });
                collected.sort((a, b) => new Date(a.date) - new Date(b.date));
                collected.reverse();
                setProjects(collected);
            }
        });
    }, []);

    useEffect(() => {
        if (!projects.length) return;
        // Prefetch every cover up front so scrolling never has to wait on
        // a network round-trip.
        projects.forEach(p => {
            if (!p || !p.image) return;
            const img = new Image();
            img.decoding = 'async';
            img.src = p.image;
        });
    }, [projects]);

    return (
        <div className="projects-home">
            <div className="projects-grid">
                {projects.map((project, idx) => (
                    <AnimatedProjectCard key={idx} index={idx}>
                        <ProjectFrame
                            projectInfo={project}
                            eager={idx < 4}
                        />
                    </AnimatedProjectCard>
                ))}
            </div>
        </div>
    );
};

export default ProjectsHome;
